import { NavigateFunction } from "react-router-dom";
import envVariables from "src/lib/envVariables";
import ensureLeadingSlash from "src/lib/sanitizePath";

const IGNORED_PARAMS = ["token", "lookupKey", "path"];
const PARAMS_TO_ADD = new URLSearchParams([["from", "tc-ott"]]);

export const handleAuthSuccess = (navigate: NavigateFunction) => {
  const currentQuery = new URLSearchParams(
    decodeURIComponent(window.location.search)
  );
  const baseName = envVariables.BASE_PATH;
  const queryPath = currentQuery.get("path") || baseName;
  IGNORED_PARAMS.forEach((key) => currentQuery.delete(key));
  const tmpUrl = new URL(ensureLeadingSlash(queryPath), window.location.origin);
  const extractedPath = tmpUrl.pathname;
  const processedSearch = new URLSearchParams(tmpUrl.search);

  const finalSearch = new URLSearchParams();
  [processedSearch, currentQuery, PARAMS_TO_ADD].forEach((params) =>
    params.forEach((value, key) => finalSearch.set(key, value))
  );

  navigate(`${extractedPath}?${finalSearch.toString()}`, { replace: true });
};
